import MenuName from "@/pages/components/MenuName/index.jsx";
import { 
  DashboardOutlined,
  AppstoreOutlined, 
  UserOutlined,
  ShoppingCartOutlined,
  CrownOutlined,
  BankOutlined,
  NodeIndexOutlined,
  AuditOutlined,
  DatabaseOutlined,
  ClusterOutlined,
  GiftOutlined
} from "@ant-design/icons";

const menus = [
  {
    key: '/',
    label: <MenuName keyName="adminNavigation.dashboard" />,
    icon: <DashboardOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
  },
  {
    key: '/application-manager',
    label: <MenuName keyName="adminNavigation.applications" />,
    icon: <AppstoreOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
    children: [
      {
        key: '/channel-application',
        label: <MenuName keyName="adminNavigation.channelApplications" />,
      },{
        key: '/home-application',
        label: <MenuName keyName="adminNavigation.homeApplications" />,
      },{
        key: '/customer-application',
        label: <MenuName keyName="adminNavigation.customerApplications" />,
      },
    ]
  },
  {
    key: '/customer',
    label: <MenuName keyName="adminNavigation.customers" />,
    icon: <UserOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
    children: [
      {
        key: '/customer/list',
        label: <MenuName keyName="adminNavigation.customerList" />,
      },{
        key: '/customer/invite',
        label: <MenuName keyName="adminNavigation.referredCustomers" />,
      },
    ]
  },
  {
    key: '/order-center',
    label: <MenuName keyName="adminNavigation.orders" />,//'智能作图',
    icon: <ShoppingCartOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
  },

  {
    key: '/package-management',
    label: <MenuName keyName="adminNavigation.plans" />,
    icon: <GiftOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
  },

  {
    key: '/marketing',
    label: <MenuName keyName="adminNavigation.marketing" />,
    icon: <CrownOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
    children: [
      {
        key: '/marketing/salesman',
        label: <MenuName keyName="adminNavigation.marketingMembers" />,
      },
      {
        key: '/marketing/redemption-code',
        label: <MenuName keyName="adminNavigation.redemptionCodes" />,
      },
    ]
  },
  {
    key: '/enterprise',
    label: <MenuName keyName="adminNavigation.companies" />,
    icon: <BankOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
    children: [
      {
        key: '/enterprise/list',
        label: <MenuName keyName="adminNavigation.companyPlans" />,
      },
    ]
  },
  {
    key: '/workflow-management',
    label: <MenuName keyName="adminNavigation.workflows" />,
    icon: <NodeIndexOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
    children: [
      {
        key: '/workflow-management/label',
        label: <MenuName keyName="adminNavigation.labels" />,
      },
      {
        key: '/workflow-management/classification',
        label: <MenuName keyName="adminNavigation.categories" />,
      },
      {
        key: '/workflow-management/workflow',
        label: <MenuName keyName="adminNavigation.workflows" />,
      },
      {
        key: '/workflow-management/agent',
        label: <MenuName keyName="adminNavigation.agents" />,
      },
      {
        key: '/workflow-management/compute-rule',
        label: <MenuName keyName="adminNavigation.computeRules" />,
      },
    ]
  },
  {
    key: '/content',
    label: <MenuName keyName="adminNavigation.content" />,
    icon: <AuditOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
  },
  {
    key: '/gpu-pool',
    label: <MenuName keyName="adminNavigation.gpuPools" />,
    icon: <DatabaseOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
  },
  {
    key: '/task-management',
    label: <MenuName keyName="adminNavigation.tasks" />,
    icon: <ClusterOutlined style={{height: '14px', width: '14px', marginRight: '10px'}}/>,
  },
];

export default menus;